import * as React from 'react';

// tslint:disable:max-line-length
export const ChurchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M14 4h-4V1c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1v3H2c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h4v7c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V8h4c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1z"
    />
  </svg>
);
